/**
 * URL Builder Utility
 * Builds URLs with query parameters for API key and email in dev mode
 */

/**
 * Appends query parameters to a URL
 * @param {string} url - Base URL
 * @param {Object} params - Parameters to append
 * @returns {string} - URL with query parameters
 */
export const appendQueryParams = (url, params) => {
  if (!url || !params || Object.keys(params).length === 0) {
    return url;
  }

  const urlObj = new URL(url);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      urlObj.searchParams.append(key, value);
    }
  });

  return urlObj.toString();
};

/**
 * Extracts existing query parameters from URL
 * @param {string} url - URL to parse
 * @returns {Object} - Query parameters object
 */
export const parseQueryParams = (url) => {
  if (!url) return {};

  try {
    const urlObj = new URL(url);
    const params = {};

    urlObj.searchParams.forEach((value, key) => {
      params[key] = value;
    });

    return params;
  } catch (error) {
    console.error('Failed to parse URL:', error);
    return {};
  }
};

/**
 * Builds WebSocket URL with API key and email as query parameters
 * @param {string} baseUrl - Base WebSocket URL from env
 * @param {string} apiKey - User's API key
 * @param {string} email - User's email
 * @returns {string} - Complete WebSocket URL with query params
 */
export const buildWebSocketUrl = (baseUrl, apiKey, email) => {
  if (!baseUrl) return '';
  if (!apiKey || !email) return baseUrl;

  return appendQueryParams(baseUrl, {
    'api-key': apiKey,
    email: email
  });
};

/**
 * Builds REST API URL with API key and email as query parameters
 * @param {string} baseUrl - Base API URL from env
 * @param {string} apiKey - User's API key
 * @param {string} email - User's email
 * @returns {string} - Complete REST API URL with query params
 */
export const buildRestApiUrl = (baseUrl, apiKey, email) => {
  if (!baseUrl) return '';
  if (!apiKey || !email) return baseUrl;

  return appendQueryParams(baseUrl, {
    'api-key': apiKey,
    email: email
  });
};
